function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#00abc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.207,
    cy: 13.8,
    r: 2.018,
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.207,11.507c.12-.001.165-.077.165-.167,0-.12-.165-.691-.165-.691,0,0-.165.572-.165.691,0,.09.045.167.165.167Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M18.501,13.8c.002.12.076.165.167.165.12,0,.692-.165.692-.165,0,0-.572-.165-.692-.165-.091,0-.167.045-.167.165Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M16.207,16.094c-.12.001-.165.077-.165.167,0,.12.165.691.165.691,0,0,.165-.572.165-.691,0-.091-.045-.167-.165-.167Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M13.914,13.8c-.002-.12-.076-.165-.167-.165-.12,0-.692.165-.692.165,0,0,.572.165.692.165.09,0,.167-.045.167-.165Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M17.085,11.681c.111.045.182-.008.216-.091.046-.111.112-.702.112-.702,0,0-.371.465-.417.576-.034.083-.022.171.089.217Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M18.326,14.678c-.045.111.008.182.091.216.111.046.702.112.702.112,0,0-.465-.371-.576-.417-.083-.034-.171-.022-.217.089Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M15.329,15.919c-.111-.045-.182.008-.216.091-.046.111-.112.702-.112.702,0,0,.371-.465.417-.576.035-.083.022-.171-.089-.217Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M14.088,12.922c.045-.111-.008-.182-.091-.216-.111-.046-.702-.112-.702-.112,0,0,.465.371.576.417.083.034.171.022.217-.089Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M17.829,12.178c.086.084.171.063.234-.001.085-.085.372-.606.372-.606,0,0-.521.287-.606.372-.063.064-.085.15,0,.235Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M17.829,15.422c-.084.086-.063.171,0,.234.085.085.606.372.606.372,0,0-.287-.521-.372-.606-.064-.063-.15-.085-.235,0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M14.585,15.422c-.086-.084-.171-.063-.234.001-.085.085-.372.606-.372.606,0,0,.521-.287.606-.372.063-.064.085-.15,0-.235Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M14.585,12.178c.084-.086.063-.171-.001-.234-.085-.085-.606-.372-.606-.372,0,0,.287.521.372.606.065.063.15.085.235,0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M18.326,12.922c.047.11.134.123.217.089.111-.046.576-.417.576-.417,0,0-.591.066-.702.112-.083.035-.137.105-.091.216Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M17.085,15.919c-.11.047-.123.134-.089.217.046.111.417.576.417.576,0,0-.066-.591-.112-.702-.035-.084-.105-.137-.216-.091Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M14.088,14.678c-.047-.11-.134-.123-.217-.089-.111.046-.576.417-.576.417,0,0,.591-.066.702-.112.084-.035.137-.105.091-.216Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M15.329,11.681c.11-.047.123-.134.089-.217-.046-.111-.417-.576-.417-.576,0,0,.066.591.112.702.035.084.106.137.216.091Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a16",
    "data-name": "a",
    d: "M16.655,11.551c.118.022.177-.043.194-.131.023-.118-.027-.71-.027-.71,0,0-.273.528-.297.646-.017.087.012.171.13.195Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a17",
    "data-name": "a",
    d: "M18.457,14.247c-.022.118.043.177.131.194.118.023.71-.027.71-.027,0,0-.528-.273-.646-.297-.088-.016-.172.013-.195.13Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18",
    "data-name": "a",
    d: "M15.76,16.049c-.118-.022-.177.043-.194.131-.023.118.027.71.027.71,0,0,.273-.528.297-.646.017-.087-.013-.171-.13-.195Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a19",
    "data-name": "a",
    d: "M13.958,13.353c.022-.118-.043-.177-.131-.194-.118-.023-.71.027-.71.027,0,0,.528.273.646.297.087.016.171-.013.195-.13Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a20",
    "data-name": "a",
    d: "M17.481,11.893c.101.065.18.028.23-.047.067-.1.247-.667.247-.667,0,0-.455.384-.521.483-.05.076-.055.164.044.231Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a21",
    "data-name": "a",
    d: "M18.114,15.074c-.065.101-.028.18.047.23.1.067.667.247.667.247,0,0-.384-.455-.483-.521-.076-.05-.164-.056-.231.044Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22",
    "data-name": "a",
    d: "M14.933,15.707c-.101-.065-.18-.028-.23.047-.067.1-.247.667-.247.667,0,0,.455-.384.521-.483.051-.076.056-.164-.044-.231Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a23",
    "data-name": "a",
    d: "M14.3,12.526c.065-.101.028-.18-.047-.23-.1-.067-.667-.247-.667-.247,0,0,.384.455.483.521.076.05.164.056.231-.044Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a24",
    "data-name": "a",
    d: "M18.114,12.526c.068.099.155.095.23.045.1-.067.483-.521.483-.521,0,0-.567.18-.667.247-.074.049-.113.129-.046.229Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25",
    "data-name": "a",
    d: "M17.481,15.707c-.099.068-.095.155-.045.23.067.1.521.483.521.483,0,0-.18-.567-.247-.667-.049-.074-.129-.113-.229-.046Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a26",
    "data-name": "a",
    d: "M14.3,15.074c-.068-.099-.155-.095-.23-.045-.1.067-.483.521-.483.521,0,0,.567-.18.667-.247.074-.049.113-.129.046-.229Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a27",
    "data-name": "a",
    d: "M14.933,11.893c.099-.068.095-.155.045-.23-.067-.1-.521-.483-.521-.483,0,0,.18.567.247.667.049.074.129.113.229.046Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a28",
    "data-name": "a",
    d: "M18.457,13.353c.025.117.107.147.195.129.118-.023.646-.297.646-.297,0,0-.593-.05-.71-.027-.089.018-.155.077-.131.195Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a29",
    "data-name": "a",
    d: "M16.655,16.049c-.117.025-.147.107-.129.195.023.118.297.646.297.646,0,0,.05-.593.027-.71-.019-.088-.078-.154-.195-.131Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a30",
    "data-name": "a",
    d: "M13.958,14.247c-.025-.117-.107-.147-.195-.129-.118.023-.646.297-.646.297,0,0,.593.05.71.027.088-.018.154-.077.131-.195Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a31",
    "data-name": "a",
    d: "M15.76,11.551c.117-.025.147-.107.129-.195-.023-.118-.297-.646-.297-.646,0,0-.05.593-.027.71.018.088.077.154.195.131Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.847,18.172c-.054.003-.106.01-.158.026-.07.01-.138.034-.208.046l-.028.004-.047.004c.003.013.005.026.005.039,0,.014-.001.026-.005.038-.003.01-.013.023-.02.031-.01.011-.02.021-.033.026-.012.006-.025.009-.039.01-.014,0-.027,0-.04-.005-.014-.005-.026-.013-.038-.023-.014.003-.028.006-.042.008-.014.001-.027.001-.039,0-.014-.004-.029-.009-.042-.014-.014-.006-.027-.012-.039-.02-.051.03-.108.059-.139.111-.017.024-.021.051-.025.08-.003.035.006.072.021.105.006.009.01-.035.027-.041.029-.023.064-.04.1-.05.03-.016.026.001.014.025-.003.013-.02.06.003.036.102-.045.214-.054.324-.062.159-.017.318-.02.478-.022l.45.009c.072.002.144.018.214.006.017-.005.044-.005.054-.016-.032-.018-.07-.019-.105-.023h-.286c-.08-.008-.162-.009-.237-.039-.02-.008-.039-.027-.058-.007-.029.01-.059.017-.089.019-.052.004-.105-.007-.153-.027.035-.048.077-.091.115-.136-.031-.005-.061-.012-.092-.019.054-.036.104-.079.157-.119h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.183,18.69c-.109.065-.192-.05-.282-.085-.065.035-.071.153-.132.209-.073.083-.161-.023-.155-.104-.087.073-.131.239-.271.217-.066-.054-.116-.168-.167-.038-.041.063-.152.153-.209.058-.018-.084-.06-.184-.106-.05-.032.095-.133.165-.231.123-.054-.044.043-.206-.025-.194-.102.067-.161.235-.304.221-.055-.062.034-.167-.027-.236-.072.092-.151.226-.275.236-.06-.048.002-.188-.036-.208-.127.076-.261.212-.421.169.062-.238.322-.322.541-.34.376-.046.772.039,1.134-.097.059-.036.2-.086.15-.169-.045-.065.116-.04.132-.116-.01-.096.074-.083.155-.092.366-.016.727.061,1.091.074.028.178-.17.302-.328.247-.076.012-.189-.174-.167-.039-.013.073-.002.167-.067.214M15.072,18.326c.085.077.144-.015.223-.048.265-.091.497-.251.725-.41.138-.114.258-.263.444-.3.362-.11.747-.096,1.111-.197.277-.379.747-.514,1.141-.732.088-.027.123-.1.151-.181.15-.237.355-.448.598-.592.115-.063.251-.099.381-.07-.009.155-.098.292-.205.399.088-.002.163-.057.252-.054.03.159-.141.242-.232.34.051.012.245.027.139.077-.135.094-.289.158-.414.267.115.021.128.045.011.087-.063.043-.185.058-.197.142.087.053-.04.106-.089.124-.094.022-.192.062-.068.134-.047.071-.148.086-.23.079.025.081.061.171-.043.206-.234.177-.509.306-.804.336.368.028.747-.04,1.062-.24.042-.049.259-.102.137-.143-.057-.024-.18-.05-.189-.094.17-.105.385-.068.568-.13.005-.059-.139-.043-.193-.056-.128-.01-.121-.043.003-.055.156-.041.333-.05.465-.151-.107-.05-.242-.006-.356-.046.194-.085.422-.093.596-.221.079-.088-.101-.061-.154-.058-.107.019-.157-.033-.035-.077.208-.153.471-.253.618-.475.035-.05.081-.2-.029-.146-.145.048-.273.212-.438.161.326-.253.636-.54.859-.89.012-.101-.147-.112-.188-.033-.209.202-.399.44-.667.567.257-.248.469-.541.654-.846.04-.09.146-.199.089-.3-.093-.077-.21-.007-.259.086-.163.213-.286.461-.496.634.183-.35.373-.722.378-1.126,0-.083-.017-.205-.13-.19-.089.016-.068.15-.105.218-.081.276-.119.574-.286.816.037-.224.103-.457.053-.684-.024-.101-.187-.058-.166.042-.195.988-.858,1.852-1.725,2.352-.397.225-.84.369-1.291.435-.121.027-.253.011-.369.052-.281.215-.451.576-.807.689-.159.079-.367.095-.481.243-.01.016-.012.038-.012.059",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,17.324c-.052.095-.083.205-.151.29-.203-.185-.498-.179-.755-.191-.213-.011-.444-.031-.608-.183-.173-.142-.314-.326-.508-.441-.177-.048-.354-.108-.496-.229-.303-.247-.477-.614-.773-.869-.057-.056-.123-.099-.186-.146-.06.015-.033.144-.107.078-.04-.029-.14-.031-.149.009.091.119.181.256.194.408-.062.006-.172-.013-.202.01.082.123.187.232.307.319-.057.009-.17.004-.192.027.119.097.246.195.401.22.032.042-.047.123.019.159.038.016.164.042.077.085-.06.04-.037.134.039.132.048.025.156.031.165.073-.043.043-.175.095-.062.136.106.059.226.097.347.101-.061.051-.135.08-.197.128.278.163.587.27.891.374.121.041.244.078.37.102-.366-.021-.719-.129-1.052-.277-.173-.076-.346-.149-.523-.214.078-.04.167-.05.248-.085-.167-.033-.349-.044-.496-.136.023-.04.108-.042.155-.062.089-.021.144-.047.019-.055-.126-.034-.271-.019-.382-.095.007-.046.123-.03.171-.049.06-.01.126-.019.174-.059-.195-.081-.45-.024-.603-.196-.035-.066.109-.013.15-.024.105,0,.217.033.317-.009-.284-.125-.588-.241-.805-.472-.024-.037-.096-.138-.038-.151.169.022.291.206.471.178.024-.032-.105-.085-.137-.131-.263-.226-.518-.47-.702-.766-.013-.099.142-.113.183-.037.201.194.383.42.633.552.089.043-.051-.051-.07-.085-.231-.269-.452-.553-.613-.869-.029-.057-.077-.16.01-.191.087-.043.173.016.216.09.17.215.295.47.507.648-.181-.35-.373-.719-.378-1.122.004-.078.009-.196.115-.193.089-.013.075.1.104.155.088.296.126.617.302.878-.039-.22-.096-.446-.058-.669.009-.073.091-.096.145-.051.044.107.053.238.092.352.226.773.733,1.452,1.394,1.909.544.373,1.19.596,1.85.635.058.004.117.006.177.009",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.3,
    cy: 18.313,
    r: 0.036,
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.297,
    cy: 18.308,
    r: 0.014,
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.297,18.325c-.01,0-.017-.008-.017-.017s.008-.017.017-.017c.01,0,.017.008.017.017s-.007.017-.017.017ZM15.297,18.296c-.006,0-.012.005-.012.012s.005.012.012.012c.006,0,.012-.005.012-.012s-.006-.012-.012-.012Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,8.594s-.144-.121-.193-.06c-.079.098.242.585.242.756,0,.281-.188.358-.42.398-.156.027-.409-.011-.409-.011.048-.064.079-.083.159-.088-.089-.046-.181-.147-.181-.304,0-.242.1-.342.1-.615,0-.151-.124-.344-.124-.344.219.022.328.225.266.388.035.005.067-.003.094-.029.016.045-.009.097-.043.142.027.015.047.006.091-.003-.004.046-.032.096-.1.142.197-.051.319.086.319.23,0,.109-.076.187-.151.187-.024,0-.059-.01-.079-.025-.014.03-.007.07.008.1-.055-.014-.089-.047-.065-.114-.042-.004-.075-.018-.098-.045.023-.029.058-.046.098-.045-.031-.063.003-.098.053-.127,0,0-.032.127.049.127.036,0,.069-.012.069-.065,0-.046-.041-.111-.134-.107-.094.004-.17.065-.17.215,0,.138.112.207.258.211.132.004.232-.068.232-.204,0-.182-.263-.597-.263-.759,0-.122.109-.19.216-.19.139,0,.256.137.256.137l-.08.102h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M1.83,11.882c0,.304-.273.46-.487.46-.289,0-.443-.173-.443-.399,0-.128.023-.209.083-.331l.662-1.375c.023-.048.031-.102.031-.182,0-.123-.12-.224-.245-.227-.114-.003-.239.107-.239.231,0,.151.079.219.159.219.099,0,.139-.041.139-.11,0-.049-.023-.07-.057-.07-.085,0-.061.115-.061.115-.042-.009-.077-.052-.057-.106-.032-.007-.061-.024-.083-.049.023-.022.049-.039.083-.045-.02-.066.007-.098.064-.111-.012.025-.012.049-.008.071.091-.026.23.015.23.172,0,.155-.108.286-.31.254.048.023.073.07.078.123-.037-.014-.078-.016-.078-.016.024.042.057.078.055.16-.038-.017-.072-.049-.12-.029.075.148-.017.353-.253.401.086-.101.129-.21.129-.319,0-.352-.098-.412-.098-.657,0-.103.053-.213.157-.288v.004c-.069-.018-.113-.052-.139-.099.158-.045.387-.044.51.005.142.016.24.125.269.18s.086.254,0,.434l-.673,1.428c-.029.062-.047.129-.047.201,0,.18.165.243.259.243.112,0,.227-.085.227-.192,0-.068-.037-.108-.09-.108-.127,0-.119.108-.094.176-.079-.035-.125-.099-.112-.166-.045-.006-.087-.027-.127-.072.031-.039.069-.069.127-.07-.025-.104.044-.148.112-.172-.022.076-.036.164.094.164.095,0,.169.016.212.078l.01-.405c.005-.121-.163-.118-.269-.082.04-.14.123-.216.314-.196-.046-.019-.096-.063-.096-.147,0-.114.092-.24.153-.277l.029,1.181h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M1.83,12.794c0-.304-.273-.46-.487-.46-.289,0-.443.173-.443.399,0,.128.023.209.083.331l.662,1.375c.023.048.031.102.031.182,0,.123-.12.224-.245.227-.114.003-.239-.107-.239-.231,0-.151.079-.219.159-.219.099,0,.139.041.139.11,0,.049-.023.07-.057.07-.085,0-.061-.115-.061-.115-.042.009-.077.052-.057.106-.032.007-.061.024-.083.049.023.022.049.039.083.045-.02.066.007.098.064.112-.012-.025-.012-.049-.008-.071.091.026.23-.015.23-.172,0-.155-.108-.286-.31-.254.048-.023.073-.07.078-.123-.037.014-.078.016-.078.016.024-.042.057-.078.055-.16-.038.017-.072.049-.12.029.075-.148-.017-.353-.253-.401.086.101.129.21.129.319,0,.352-.098.412-.098.657,0,.103.053.213.157.288v-.004c-.071.021-.115.055-.141.101.158.045.387.044.51-.005.142-.016.24-.125.269-.18s.086-.254,0-.434l-.673-1.428c-.029-.062-.047-.129-.047-.2,0-.18.165-.243.259-.243.112,0,.227.086.227.192,0,.068-.037.108-.09.108-.127,0-.119-.108-.094-.176-.079.036-.125.099-.112.166-.045.006-.087.027-.127.072.031.039.069.068.127.07-.025.104.044.148.112.172-.022-.076-.036-.164.094-.164.095,0,.169-.016.212-.078l.01.405c.005.121-.163.118-.269.082.04.14.123.216.314.196-.046.019-.096.063-.096.147,0,.114.092.24.153.277l.031-1.185h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,8.594s.144-.121.193-.06c.079.098-.242.585-.242.756,0,.281.188.358.42.398.156.027.409-.011.409-.011-.048-.064-.079-.083-.159-.088.089-.046.181-.147.181-.304,0-.242-.1-.342-.1-.615,0-.151.124-.344.124-.344-.219.022-.328.225-.266.388-.035.005-.067-.003-.094-.029-.016.045.009.097.043.142-.027.015-.047.006-.091-.003.004.046.032.096.1.142-.197-.051-.319.086-.319.23,0,.109.076.187.151.187.024,0,.059-.01.079-.025.014.03.007.07-.008.1.055-.014.089-.047.065-.114.042-.004.075-.018.098-.045-.023-.029-.058-.046-.098-.045.031-.063-.003-.098-.053-.127,0,0,.032.127-.049.127-.036,0-.069-.012-.069-.065,0-.046.041-.111.134-.107.094.004.17.065.17.215,0,.138-.112.207-.258.211-.132.004-.233-.068-.233-.204,0-.182.263-.597.263-.759,0-.122-.109-.19-.216-.19-.139,0-.256.137-.256.137l.081.102h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d2",
    "data-name": "d",
    d: "M1.77,11.882c0,.304.273.46.487.46.289,0,.443-.173.443-.399,0-.128-.023-.209-.083-.331l-.662-1.375c-.023-.048-.031-.102-.031-.182,0-.123.12-.224.245-.227.114-.003.239.107.239.231,0,.151-.079.219-.159.219-.099,0-.139-.041-.139-.11,0-.049.023-.07.057-.07.085,0,.061.115.061.115.042-.009.077-.052.057-.106.032-.007.061-.024.083-.049-.023-.022-.049-.039-.083-.045.02-.066-.007-.098-.064-.111.012.025.012.049.008.071-.09-.027-.229.014-.229.17,0,.155.108.286.31.254-.048.023-.073.07-.078.123.037-.014.078-.016.078-.016-.024.042-.057.078-.055.16.037-.017.072-.049.12-.029-.075.148.017.353.253.401-.086-.101-.129-.21-.129-.319,0-.352.098-.412.098-.657,0-.103-.053-.213-.157-.288v.004c.069-.018.113-.052.139-.099-.158-.045-.387-.044-.51.005-.142.016-.24.125-.269.18s-.086.254,0,.434l.673,1.428c.029.062.047.129.047.201,0,.18-.165.243-.259.243-.112,0-.227-.085-.227-.192,0-.068.037-.108.09-.108.127,0,.119.108.094.176.079-.035.125-.099.112-.166.045-.006.087-.027.127-.072-.031-.039-.069-.069-.127-.07.025-.104-.044-.148-.112-.172.022.076.036.164-.094.164-.095,0-.169.016-.212.078l-.01-.405c-.005-.121.163-.118.269-.082-.04-.14-.123-.216-.314-.196.046-.019.096-.063.096-.147,0-.114-.092-.24-.153-.277l-.03,1.183h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3",
    "data-name": "d",
    d: "M1.77,12.794c0-.304.273-.46.487-.46.289,0,.443.173.443.399,0,.128-.023.209-.083.331l-.662,1.375c-.023.048-.031.102-.031.182,0,.123.12.224.245.227.114.003.239-.107.239-.231,0-.151-.079-.219-.159-.219-.099,0-.139.041-.139.11,0,.049.023.07.057.07.085,0,.061-.115.061-.115.042.009.077.052.057.106.032.007.061.024.083.049-.023.022-.049.039-.083.045.02.066-.007.098-.064.112.012-.025.012-.049.008-.071-.09.027-.229-.014-.229-.171,0-.155.108-.286.31-.254-.048-.023-.073-.07-.078-.123.037.014.078.016.078.016-.024-.042-.057-.078-.055-.16.037.017.072.049.12.029-.075-.148.017-.353.253-.401-.086.101-.129.21-.129.319,0,.352.098.412.098.657,0,.103-.053.213-.157.288v-.004c.07.02.114.054.14.1-.158.045-.387.044-.51-.005-.142-.016-.24-.125-.269-.18s-.086-.254,0-.434l.673-1.428c.029-.062.047-.129.047-.2,0-.18-.165-.243-.259-.243-.112,0-.227.086-.227.192,0,.068.037.108.09.108.127,0,.119-.108.094-.176.079.036.125.099.112.166.045.006.087.027.127.072-.031.039-.069.068-.127.07.025.104-.044.148-.112.172.022-.076.036-.164-.094-.164-.095,0-.169-.016-.212-.078l-.01.405c-.005.121.163.118.269.082-.04.14-.123.216-.314.196.046.019.096.063.096.147,0,.114-.092.24-.153.277l-.031-1.185h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,21.406s-.144.121-.193.06c-.079-.098.242-.585.242-.756,0-.281-.188-.358-.42-.398-.156-.027-.409.011-.409.011.048.064.079.083.159.088-.089.046-.181.147-.181.304,0,.242.1.342.1.615,0,.151-.124.344-.124.344.219-.022.328-.225.266-.388.035-.005.067.003.094.029.016-.045-.009-.097-.043-.142.027-.015.047-.006.091.003-.004-.046-.032-.096-.1-.142.197.051.319-.086.319-.23,0-.109-.076-.187-.151-.187-.024,0-.059.01-.079.025-.014-.03-.007-.07.008-.1-.055.014-.089.047-.065.114-.042.004-.075.018-.098.045.023.029.058.046.098.045-.031.063.003.098.053.127,0,0-.032-.127.049-.127.036,0,.069.012.069.065,0,.046-.041.111-.134.107-.094-.004-.17-.065-.17-.215,0-.138.112-.207.258-.211.132-.004.232.068.232.204,0,.182-.263.597-.263.759,0,.122.109.19.216.19.139,0,.256-.137.256-.137l-.08-.102h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d4",
    "data-name": "d",
    d: "M1.83,18.118c0-.304-.273-.46-.487-.46-.289,0-.443.173-.443.399,0,.128.023.209.083.331l.662,1.375c.023.048.031.102.031.182,0,.123-.12.224-.245.227-.114.003-.239-.107-.239-.231,0-.151.079-.219.159-.219.099,0,.139.041.139.11,0,.049-.023.07-.057.07-.085,0-.061-.115-.061-.115-.042.009-.077.052-.057.106-.032.007-.061.024-.083.049.023.022.049.039.083.045-.02.066.007.098.064.111-.012-.025-.012-.049-.008-.071.091.026.23-.015.23-.172,0-.155-.108-.286-.31-.254.048-.023.073-.07.078-.123-.037.014-.078.016-.078.016.024-.042.057-.078.055-.16-.038.017-.072.049-.12.029.075-.148-.017-.353-.253-.401.086.101.129.21.129.319,0,.352-.098.412-.098.657,0,.103.053.213.157.288v-.004c-.069.018-.113.052-.139.099.158.045.387.044.51-.005.142-.016.24-.125.269-.18s.086-.254,0-.434l-.673-1.428c-.029-.062-.047-.129-.047-.201,0-.18.165-.243.259-.243.112,0,.227.085.227.192,0,.068-.037.108-.09.108-.127,0-.119-.108-.094-.176-.079.035-.125.099-.112.166-.045.006-.087.027-.127.072.031.039.069.069.127.07-.025.104.044.148.112.172-.022-.076-.036-.164.094-.164.095,0,.169-.016.212-.078l.01.405c.005.121-.163.118-.269.082.04.14.123.216.314.196-.046.019-.096.063-.096.147,0,.114.092.24.153.277l.029-1.181h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d5",
    "data-name": "d",
    d: "M1.83,17.206c0,.304-.273.46-.487.46-.289,0-.443-.173-.443-.399,0-.128.023-.209.083-.331l.662-1.375c.023-.048.031-.102.031-.182,0-.123-.12-.224-.245-.227-.114-.003-.239.107-.239.231,0,.151.079.219.159.219.099,0,.139-.041.139-.11,0-.049-.023-.07-.057-.07-.085,0-.061.115-.061.115-.042-.009-.077-.052-.057-.106-.032-.007-.061-.024-.083-.049.023-.022.049-.039.083-.045-.02-.066.007-.098.064-.112-.012.025-.012.049-.008.071.091-.026.23.015.23.172,0,.155-.108.286-.31.254.048.023.073.07.078.123-.037-.014-.078-.016-.078-.016.024.042.057.078.055.16-.038-.017-.072-.049-.12-.029.075.148-.017.353-.253.401.086-.101.129-.21.129-.319,0-.352-.098-.412-.098-.657,0-.103.053-.213.157-.288v.004c-.071-.021-.115-.055-.141-.101.158-.045.387-.044.51.005.142.016.24.125.269.18s.086.254,0,.434l-.673,1.428c-.029.062-.047.129-.047.2,0,.18.165.243.259.243.112,0,.227-.086.227-.192,0-.068-.037-.108-.09-.108-.127,0-.119.108-.094.176-.079-.036-.125-.099-.112-.166-.045-.006-.087-.027-.127-.072.031-.039.069-.068.127-.07-.025-.104.044-.148.112-.172-.022.076-.036.164.094.164.095,0,.169.016.212.078l.01-.405c.005-.121-.163-.118-.269-.082.04-.14.123-.216.314-.196-.046-.019-.096-.063-.096-.147,0-.114.092-.24.153-.277l.031,1.185h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,21.406s.144.121.193.06c.079-.098-.242-.585-.242-.756,0-.281.188-.358.42-.398.156-.027.409.011.409.011-.048.064-.079.083-.159.088.089.046.181.147.181.304,0,.242-.1.342-.1.615,0,.151.124.344.124.344-.219-.022-.328-.225-.266-.388-.035-.005-.067.003-.094.029-.016-.045.009-.097.043-.142-.027-.015-.047-.006-.091.003.004-.046.032-.096.1-.142-.197.051-.319-.086-.319-.23,0-.109.076-.187.151-.187.024,0,.059.01.079.025.014-.03.007-.07-.008-.1.055.014.089.047.065.114.042.004.075.018.098.045-.023.029-.058.046-.098.045.031.063-.003.098-.053.127,0,0,.032-.127-.049-.127-.036,0-.069.012-.069.065,0,.046.041.111.134.107.094-.004.17-.065.17-.215,0-.138-.112-.207-.258-.211-.132-.004-.233.068-.233.204,0,.182.263.597.263.759,0,.122-.109.19-.216.19-.139,0-.256-.137-.256-.137l.081-.102h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d6",
    "data-name": "d",
    d: "M1.77,18.118c0-.304.273-.46.487-.46.289,0,.443.173.443.399,0,.128-.023.209-.083.331l-.662,1.375c-.023.048-.031.102-.031.182,0,.123.12.224.245.227.114.003.239-.107.239-.231,0-.151-.079-.219-.159-.219-.099,0-.139.041-.139.11,0,.049.023.07.057.07.085,0,.061-.115.061-.115.042.009.077.052.057.106.032.007.061.024.083.049-.023.022-.049.039-.083.045.02.066-.007.098-.064.111.012-.025.012-.049.008-.071-.09.027-.229-.014-.229-.17,0-.155.108-.286.31-.254-.048-.023-.073-.07-.078-.123.037.014.078.016.078.016-.024-.042-.057-.078-.055-.16.037.017.072.049.12.029-.075-.148.017-.353.253-.401-.086.101-.129.21-.129.319,0,.352.098.412.098.657,0,.103-.053.213-.157.288v-.004c.069.018.113.052.139.099-.158.045-.387.044-.51-.005-.142-.016-.24-.125-.269-.18s-.086-.254,0-.434l.673-1.428c.029-.062.047-.129.047-.201,0-.18-.165-.243-.259-.243-.112,0-.227.085-.227.192,0,.068.037.108.09.108.127,0,.119-.108.094-.176.079.035.125.099.112.166.045.006.087.027.127.072-.031.039-.069.069-.127.07.025.104-.044.148-.112.172.022-.076.036-.164-.094-.164-.095,0-.169-.016-.212-.078l-.01.405c-.005.121.163.118.269.082-.04.14-.123.216-.314.196.046.019.096.063.096.147,0,.114-.092.24-.153.277l-.03-1.183h0Z",
    style: {
      fill: "#ffec2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d7",
    "data-name": "d",
    d: "M1.77,17.206c0,.304.273.46.487.46.289,0,.443-.173.443-.399,0-.128-.023-.209-.083-.331l-.662-1.375c-.023-.048-.031-.102-.031-.182,0-.123.12-.224.245-.227.114-.003.239.107.239.231,0,.151-.079.219-.159.219-.099,0-.139-.041-.139-.11,0-.049.023-.07.057-.07.085,0,.061.115.061.115.042-.009.077-.052.057-.106.032-.007.061-.024.083-.049-.023-.022-.049-.039-.083-.045.02-.066-.007-.098-.064-.112.012.025.012.049.008.071-.09-.027-.229.014-.229.171,0,.155.108.286.31.254-.048.023-.073.07-.078.123.037-.014.078-.016.078-.016-.024.042-.057.078-.055.16.037-.017.072-.049.12-.029-.075.148.017.353.253.401-.086-.101-.129-.21-.129-.319,0-.352.098-.412.098-.657,0-.103-.053-.213-.157-.288v.004c.07-.02.114-.054.14-.1-.158-.045-.387-.044-.51.005-.142.016-.24.125-.269.18s-.086.254,0,.434l.673,1.428c.029.062.047.129.047.2,0,.18-.165.243-.259.243-.112,0-.227-.086-.227-.192,0-.068.037-.108.09-.108.127,0,.119.108.094.176.079-.036.125-.099.112-.166.045-.006.087-.027.127-.072-.031-.039-.069-.068-.127-.07.025-.104-.044-.148-.112-.172.022.076.036.164-.094.164-.095,0-.169.016-.212.078l-.01-.405c-.005-.121.163-.118.269-.082-.04-.14-.123-.216-.314-.196.046-.019.096-.063.096-.147,0-.114-.092-.24-.153-.277l-.031,1.185h0Z",
    style: {
      fill: "#ffec2d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKz);
export default __webpack_public_path__ + "static/media/KZ.bd1237300d57d2df994cb79444b1f91a.svg";
export { ForwardRef as ReactComponent };